import { instance } from '../utils/http.js';
import axios from 'axios'

const BASE_TEMPLATE_URL = 'https://jswebsite.sitestar.cn/api/Templates';
const BASE_SERVER_URL = 'https://jswebsite.sitestar.cn/api/Servers';
const BASE_OPERATE_URL = 'https://js.sitestar.cn/ajax/operate.ashx';
//const BASE_OPERATE_URL = 'http://localhost:58315/ajax/operate.ashx';

// 获取模板分类列表
export const getTempleCategory = () => {
  return instance.get(`${BASE_TEMPLATE_URL}/GetTempleCategory`);
};


/**
 * 获取缓存模板（redkey 可选）
 * @param {String} [redkey] - 可选的 redkey
 * @param {Object} view - 请求体内容
 */
export const getCacheTemplate = (redkey, view) => {
  const config = {
    params: {},
  };

  if (redkey) {
    config.params.redkey = redkey;
  }

  return instance.post(`${BASE_TEMPLATE_URL}/GetCacheTemplte`, view, config);
};

/**
 * 开通站点
 * @param {String} redkey - 用户凭证 key
 * @param {String|Number} tplId - 模板 ID
 */
export const openSite = (redkey, tplId) => {
  return instance.post(`${BASE_SERVER_URL}/OpenSite`, null, {
    params: {
      redkey,
      s_tplid: tplId
    }
  });
};

/**
 * 获取套餐列表（产品列表）
 * @param {String} redkey - 用户凭证 key
 * @param {Object} view - 请求体内容
 */
export const getPriceList = (redkey, view) => {
  return instance.post(`${BASE_SERVER_URL}/GetPrclst`, view, {
    params: { redkey }
  });
};


/**
 * 添加模板
 * @param {String} templateId - 模板 ID
 * @param {String} redkey - 用户 redkey
 */
export const addTemplate = (templateId, redkey) => {
  return instance.post(`${BASE_TEMPLATE_URL}/AddTemple`, null, {
    params: {
      template: templateId,
      redkey
    }
  });
};

/**
 * 获取模板分类下模块数量
 * @param {Object} params - 参数包含 temid, tpl_category_id, redkey
 */
export const getCategoryCount = (params) => {
  return instance.get(`${BASE_TEMPLATE_URL}/GetCategoryCount`, {
    params
  });
};

/**
 * 删除模板记录
 * @param {Object} params - 传入删除参数（如 id 列表和 redkey）
 */
export const deleteTemplatesRecord = (params) => {
  return instance.get(`${BASE_TEMPLATE_URL}/DelTemples`, {
    params
  });
};

// 获取案例列表
export const getCaseList = (index = 1) => {
  return instance.get(BASE_OPERATE_URL, {
    params: {
      module: 'SiteAnliList',
      index
    }
  });
};
// 获取案例总页数
export const getCaseTotalPageNum = () => {
  return instance.get(BASE_OPERATE_URL, {
    params: {
      module: 'SiteAnliTotalPageNum'
    }
  });
};
// 获取案例列表
export const getSiteMobanList = () => { 
  var v = (typeof sysCacheFlag !== 'undefined' && sysCacheFlag) ? sysCacheFlag : Date.now();
  var url="https://js.sitestar.cn/config/sitemobancache.js?v="+v;
  //var url="http://localhost:58315/config/sitemobancache.js?v="+sysCacheFlag;
  return axios.get(url, { responseType: 'text' });
};

// 获取案例总页数
export const getSiteMobanCategories = () => {
  return instance.get(BASE_OPERATE_URL, {
    params: {
      module: 'SiteMobanCategories'
    }
  });
};


// WEBPACK FOOTER //
// ./src/api/template.js